export function trnToUUID(trnString: string): string {
  const tidUuidArray = trnString.split(':');
  return tidUuidArray[tidUuidArray.length - 1];
}
